<div class="dropdown" *ngIf="selectedItem">
	<a class="dropdown-selected-item" (click)='switchSubLinks()'>{{ selectedItem.text }}</a>

    <ul class="dropdown-list" *ngIf="showSubLinks">
		<li *ngFor="let item of items" (click)="setSelectedItem(item)" class="dropdown-item">{{ item.text }}</li>
	</ul>

    <img class="sorting-arrow" [ngClass]="{ 'sorting-arrow-up': !showSubLinks }" src="../assets/images/down-arrow.svg"/>
</div>
